import ControlledTriggerIcon from "./ControlledTriggerIcon";

export default ControlledTriggerIcon;
